import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/pricing/page.tsx");
